import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { multiFileSelectAPI } from "./api";
import { logout } from "../auth/";
import { createMiddleware } from "../middlewareUtil";

// Initial state
const initialState = {
  noiseFilterStatus: "",
  selectedFile: {},
  clipId: 0,
};

export const selectFilteredFile = createAsyncThunk(
  "multiFileSelect/selectFilteredFile",
  async (
    { caseId, clipId, audioFile },
    { getState, dispatch, rejectWithValue },
  ) => {
    const accessToken = getState().auth.accessCode;

    const result = await multiFileSelectAPI.selectFilteredFile(
      accessToken,
      caseId,
      clipId,
      audioFile,
    );

    if (result.success) {
      return result.data;
    } else if (result.error === "unauthorized") {
      dispatch(logout());
      return rejectWithValue("Authentication failed");
    }

    return rejectWithValue("Failed to select noise filter file");
  },
);

// Create the slice
const multiFileSelectSlice = createSlice({
  name: "multiFileSelect",
  initialState,
  extraReducers: (builder) => {
    builder
      // Select file for noise filtering
      .addCase(selectFilteredFile.pending, (_state, _action) => {
        return cloneDeep(initialState);
      })
      .addCase(selectFilteredFile.fulfilled, (state, action) => {
        state.selectedFile = action.payload;
        state.noiseFilterStatus = "SELECTED";
      })
      .addCase(selectFilteredFile.rejected, (_state, _action) => {
        return cloneDeep(initialState);
      });
  },
});

export const multiFileSelectMiddleware = createMiddleware([
  "multiFileSelect/selectFilteredFile/pending",
]);

export default multiFileSelectSlice.reducer;
